import React, { useEffect, useState } from "react";
import FormField from "../../../components/common/FormField";
import {
  Final_Form_Field,
  invoiceVatFormElements,
  PAYMENT_METHOD_OPTIONS,
  STARTER_INVOICE_VAT_FORM_ELEMENTS,
  STORAGE_PAYMENT_METHOD_OPTIONS,
} from "./invoiceUntils";
import { Button, Grid } from "@mui/material";
import { useSelector } from "react-redux";
interface InvoiceVatFormProps {
  formData: any;
  setFormData: any;
  isFormReadyOnly?: any;
  onTriggerPayment?: any;
  invoiceDetails?: any;
  invoiceType?: string; // Optional prop to indicate the type of invoice
  isNewInvoice?: boolean; // Optional prop to indicate if it's a new invoice
}
const InvoiceVatForm: React.FC<InvoiceVatFormProps> = (props) => {
  const {
    formData,
    setFormData,
    isFormReadyOnly,
    onTriggerPayment,
    invoiceDetails,
    invoiceType,
    isNewInvoice = false,
  } = props;
  const [fixedEditable, setFixedEditable] = useState(true);

  const { userProfile } = useSelector((state: any) => state?.user);
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { paymentMethods } = useSelector((state: any) => state?.quickBook);
  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Financial") || false, // Safe fallback
  );

  useEffect(() => {
    setIsProfessionalSection(
      userProfile?.features?.includes("Professional Financial") || false,
    ); // Sync profile changes
  }, [userProfile]);
  const [isBasicDiarySection, setIsBasicDiarySection] = useState(
    userProfile?.features?.includes("Basic Work Diary") || false, // Safe fallback
  );
  const { editClientOriginalData } = useSelector(
    (state: any) => state.adminClients,
  );

  useEffect(() => {
    setIsBasicDiarySection(
      userProfile?.features?.includes("Basic Work Diary") || false,
    ); // Sync profile changes
  }, [userProfile]);

  const onChangeAction = (event: any) => {
    const { id, value } = event.target;
    if (id === "method") {
      if (isProfessionalSection) {
        // Find selected invoice type from Redux list (if exists)
        const selectedType = paymentMethods?.find(
          (type: any) => type.name === value || type.id === value,
        );

        const updatedFormData = {
          ...formData,
          method: selectedType?.name || value,
          payment_method_id: selectedType?.id || null,
        };
        setFormData(updatedFormData);
      } else {
        // Non-professional → only set name
        const updatedFormData = {
          ...formData,
          method: value,
        };
        setFormData(updatedFormData);
      }

      // Clear address fields if invoice_type is 'deposit' or 'final'
    } else {
      // Check if the clicked value is the currently selected value
      const updatedData = {
        ...formData,
        [id]: value,
      };
      if (updatedData?.is_vat_included) {
        updatedData.total_amount = !updatedData?.is_values_fixed
          ? invoiceDetails?.total_amount != null
            ? Number(invoiceDetails?.total_amount)
            : Number(updatedData?.items_total)
          : Number(updatedData?.net) + Number(updatedData?.vat_amount);
        updatedData.quick_pay = !updatedData?.is_values_fixed
          ? invoiceDetails?.quick_pay != null
            ? Number(invoiceDetails?.quick_pay)
            : Number(updatedData?.items_total)
          : Number(updatedData?.net) + Number(updatedData?.vat_amount);
        updatedData.net = !updatedData?.is_values_fixed
          ? invoiceDetails?.net != null
            ? Number(invoiceDetails?.net)
            : updatedData?.items_price
          : updatedData?.net;
        updatedData.vat_amount = !updatedData?.is_values_fixed
          ? updatedData?.items_vat
          : updatedData?.vat_amount;
      } else {
        updatedData.total_amount = !updatedData?.is_values_fixed
          ? invoiceDetails?.total_amount != null
            ? Number(invoiceDetails?.total_amount)
            : Number(updatedData?.items_total)
          : Number(updatedData?.net) + Number(updatedData?.vat_amount);
        updatedData.quick_pay = !updatedData?.is_values_fixed
          ? invoiceDetails?.quick_pay != null
            ? Number(invoiceDetails?.quick_pay)
            : Number(updatedData?.items_total)
          : Number(updatedData?.net) + Number(updatedData?.vat_amount);
        updatedData.net = !updatedData?.is_values_fixed
          ? invoiceDetails?.net != null
            ? Number(invoiceDetails?.net)
            : updatedData?.items_price
          : updatedData?.net;
        updatedData.vat_amount = !updatedData?.is_values_fixed
          ? updatedData?.items_vat
          : updatedData?.vat_amount;
      }

      setFixedEditable(!updatedData?.is_values_fixed);

      setFormData(updatedData);
    }
  };

  useEffect(() => {
    setFixedEditable(!formData?.is_values_fixed);
  }, [formData]);

  const fixedEditableAction = (id: any) => {
    if (id === "net" || id === "vat_amount") {
      return fixedEditable;
    }
    return false;
  };

  const hasStorageContract = !!formData?.contract_id && !!formData?.contract_no;

  // if professional → use Redux invoiceTypes, else → dummy
  const dynamicPaymentMethod = hasStorageContract
    ? STORAGE_PAYMENT_METHOD_OPTIONS
    : isProfessionalSection && paymentMethods?.length
      ? paymentMethods.map((item: any) => ({
          id: item.id,
          name: item.name,
          tooltip: item.description || item.tooltip || "", // << ADD TOOLTIP
        }))
      : PAYMENT_METHOD_OPTIONS;

  // -----------------------------
  // 🔹 STEP 2: Choose form structure
  // -----------------------------

  const rawFormElements = !isBasicDiarySection
    ? STARTER_INVOICE_VAT_FORM_ELEMENTS
    : invoiceVatFormElements;

  // 👇 Combine conditionally
  let FORM_ELEMENTS = [...rawFormElements];

  // -----------------------------
  // 🔹 STEP 3: Inject dynamic options into payment method field
  // -----------------------------
  const formElementsWithDynamicOptions = FORM_ELEMENTS.map((field) => {
    if (field.id === "method") {
      return { ...field, options: dynamicPaymentMethod };
    }
    return field;
  });

  useEffect(() => {
    if (!formData?.payment_terms) {
      setFormData((prevData: any) => ({
        ...prevData,
        payment_terms: editClientOriginalData?.payment_terms || "",
      }));
    }
  }, [editClientOriginalData]); // run only once on mount

  return (
    <Grid
      container
      spacing={0.5}
      sx={{
        backgroundColor: "#E5F4F1",
        border: "1px solid #CFCFCF",
        borderRadius: "5px",
        padding: "10px 6px",
        marginBottom: "4px",
      }}
    >
      {formElementsWithDynamicOptions?.map((field, i) => (
        <>
          <FormField
            key={i}
            onPaste={(e: any) => e.preventDefault()}
            onKeyDown={(event: any) => {
              if (
                event.keyCode === 8 ||
                event.keyCode === 9 ||
                event.keyCode === 37 ||
                event.keyCode === 38 ||
                event.keyCode === 39 ||
                event.keyCode === 40 ||
                event.keyCode === 18 ||
                event.keyCode === 17 ||
                event.ctrlKey
              )
                return;

              if (
                field?.patternAllowed &&
                !field?.patternAllowed.test(event.key)
              ) {
                event.preventDefault();
              } else if (
                field?.patternAllowed &&
                !field?.patternAllowed.test(event.target.value + event.key)
              ) {
                event.preventDefault();
              }
            }}
            {...{
              ...field,
              value:
                field?.id === "method"
                  ? hasStorageContract
                    ? formData?.method || ""
                    : isProfessionalSection
                      ? formData?.payment_method_id != null
                        ? String(formData.payment_method_id)
                        : ""
                      : formData?.method || ""
                  : formData?.[field?.id] !== undefined
                    ? typeof formData[field.id] === "number"
                      ? formData[field.id].toFixed(2)
                      : formData[field.id]
                    : "",
              variant: "outlined",
              onChange: onChangeAction,
              //   onBlur: onBlurAction,
              ...{
                ...(field?.type === "checkbox" && {
                  checked: formData && formData[field?.id],
                }),
              },
              isNonMarginTop: true,
              inSingleGridForm: true,
              disabled:
                field?.id === "is_vat_included"
                  ? isNewInvoice
                    ? false
                    : true
                  : isFormReadyOnly ||
                    fixedEditableAction(field?.id) ||
                    (formData?.invoice_type === "deposit" &&
                      leadDetails?.lead?.status === "JOB") ||
                    (field?.id === "status" &&
                      invoiceDetails?.status === "Paid") ||
                    ((field?.id === "method" || field?.id === "status") &&
                      [
                        "Blink Debit/Credit Card",
                        "Blink Payment Link",
                      ].includes(formData?.method)),
              //  ||( invoiceDetails?.status === "Paid"),
              InputProps: {
                ...(field?.inputProps && field?.inputProps),
                ...{
                  disabled:
                    isFormReadyOnly ||
                    fixedEditableAction(field?.id) ||
                    field?.editReadOnly ||
                    (formData?.invoice_type === "deposit" &&
                      leadDetails?.lead?.status === "JOB"),
                },
                sx:
                  field?.type === "text" || field?.type === "password"
                    ? { height: "36px" }
                    : { padding: "10px 4px", height: "36px" },
              },
              //   error: error && error[field?.id],
              //   helperText: error && error[field?.id],
            }}
          />
          {field?.id === "quick_pay" && !isBasicDiarySection && (
            <section>
              <Button
                disabled={
                  !formData?.quick_pay ||
                  !invoiceDetails?.invoice_number ||
                  ["Blink Direct Debit", "Blink Debit/Credit Card", "Blink Payment Link"].includes(
                    formData?.method,
                  )
                }
                variant="contained"
                size="small"
                onClick={onTriggerPayment}
                sx={{
                  fontSize: "10px",
                  marginLeft: "6px",
                  height: "30px",
                  marginTop: "30px",
                }}
              >
                Quick Pay
              </Button>
            </section>
          )}
        </>
      ))}
    </Grid>
  );
};

export default InvoiceVatForm;
